import { createSelector } from "reselect";
import { CaseType } from "@teamprevent/common/model";

import { OhCase, AppState, OhCaseState, OhCaseListModel, OhCaseDetailModel } from "./model";

export const routeIdSelector = (state: AppState): string => state.router.params!.ohCaseId!; // eslint-disable-line @typescript-eslint/no-non-null-assertion

export type SelectorState = AppState;

export const ohCasesSelector = (state: OhCaseState) => state.ohCases;

/**
 * @deprecated replaced by `useOhCaseDetailsModel` hook or `ohCase` selector
 */
export const ohCaseSelector = createSelector(
    ohCasesSelector,
    routeIdSelector,
    (ohCases: AppState["ohCases"], id: any) => {
        return ohCases.filter(c => c.id === id)[0] || {} as AppState["ohCases"][number];
    }
);

export const ohCase = createSelector(
    ohCasesSelector,
    routeIdSelector,
    (ohCases: (OhCaseListModel | OhCaseDetailModel)[], id: string) => {
        return ohCases.find(c => c.id === id);
    }
);

export const basePathSelector = (state: AppState) =>
    state.router.pathname!.substring( // eslint-disable-line @typescript-eslint/no-non-null-assertion
        0,
        state.router.pathname!.indexOf("ohCases") + "ohCases".length // eslint-disable-line @typescript-eslint/no-non-null-assertion
    );

export const ppqDeclarationIdSelector = createSelector(
    ohCaseSelector,
    (o: OhCase) => o.linkedOhCases?.find(loc => loc.caseType === CaseType.PPQ)?.id
);

export const ohCaseFromIdSelector = (state: OhCaseState, ohCaseId: string) => {
    return state.ohCases.filter(c => c.id === ohCaseId)[0] || null;
};
